<template>
  <div>
    <b-nav-item-dropdown right no-caret>
      <template slot="button-content">
        <i class="fa fa-user-circle-o fa-lg" style="font-size: 30px;"></i>
      </template>
      <!--<b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>
        <b-dropdown-item><i class="fa fa-bell-o"></i> Updates<b-badge variant="info">{{itemsCount}}</b-badge></b-dropdown-item>
        <b-dropdown-item><i class="fa fa-envelope-o"></i> Messages<b-badge variant="success">{{itemsCount}}</b-badge></b-dropdown-item>                                                  
        <b-dropdown-item><i class="fa fa-tasks"></i> Tasks<b-badge variant="danger">{{itemsCount}}</b-badge></b-dropdown-item>
        <b-dropdown-item><i class="fa fa-comments"></i> Comments<b-badge variant="warning">{{itemsCount}}</b-badge></b-dropdown-item>                                                   
        <b-dropdown-header tag="div" class="text-center"><strong>Settings</strong></b-dropdown-header>
        <b-dropdown-item><i class="fa fa-user"></i> Profile</b-dropdown-item>
        <b-dropdown-item><i class="fa fa-wrench"></i> Settings</b-dropdown-item>
        <b-dropdown-item><i class="fa fa-usd"></i> Payments<b-badge variant="secondary">{{itemsCount}}</b-badge></b-dropdown-item>
        <b-dropdown-item><i class="fa fa-file"></i> Projects<b-badge variant="primary">{{itemsCount}}</b-badge></b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>                            
        <b-dropdown-item><i class="fa fa-shield"></i> Lock Account</b-dropdown-item> -->
      <b-dropdown-item @click.prevent="reset_password"
        ><i class="fa fa-key"></i> Reset Password</b-dropdown-item
      >
      <b-dropdown-item @click.prevent="logout"
        ><i class="fa fa-lock"></i> Logout</b-dropdown-item
      >
    </b-nav-item-dropdown>

    <b-modal
      title="Reset Password"
      size="md"
      v-model="resetModal"
      hide-footer
      style="margin: auto;"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <b-col sm="12">
              <div
                class="alert alert-success"
                v-if="errorMessage.message != ''"
                style="text-align: center;"
              >
                {{ errorMessage.message }}
              </div>
            </b-col>
          </div>
          <div class="row">
            <b-col sm="12">
              <b-form-group>
                <label for="name"> New Password :</label>
                <b-form-input
                  type="password"
                  v-model="password.new"
                  :class="{ 'is-invalid': hasErrors.new }"
                  placeholder="New Password"
                ></b-form-input>
                <small class="form-text text-muted" v-if="hasErrors.new"
                  ><strong style="color: red;">{{
                    errorMessage.new
                  }}</strong></small
                >
              </b-form-group>
            </b-col>
          </div>
          <div class="row">
            <b-col sm="12">
              <b-form-group>
                <label for="name"> Confirm Password :</label>
                <b-form-input
                  type="password"
                  v-model="password.confirm"
                  :class="{ 'is-invalid': hasErrors.confirm }"
                  placeholder="Confirm Password"
                ></b-form-input>
                <small class="form-text text-muted" v-if="hasErrors.confirm"
                  ><strong style="color: red;">{{
                    errorMessage.confirm
                  }}</strong></small
                >
              </b-form-group>
            </b-col>
          </div>
          <b-row>
            <b-col sm="12">
              <button
                type="save"
                class="btn btn-sm btn-primary"
                @click.prevent="Submit()"
              >
                <i class="fa fa-dot-circle-o"></i> Save
              </button>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-modal>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>
<script>
import Spinner from "../../spinner.vue";
export default {
  name: "header-dropdown",
  components: {
    Spinner,
  },
  data: () => {
    return {
      loading: false,
      resetModal: false,
      password: {
        new: "",
        confirm: "",
      },
      hasErrors: {
        new: false,
        confirm: false,
      },
      errorMessage: {
        new: "",
        confirm: "",
        message: "",
      },
      itemsCount: 42,
    };
  },
  methods: {
    logout() {
      var _this = this;
      _this.loading = true;
      this.$http
        .post("/api/users/logout")
        .then(function (response) {
          _this.loading = false;
        })
        .catch(function (error) {
          _this.loading = false;
        });
      localStorage.clear();
      _this.$store.commit("SET_AUTH_USER", null);
      _this.$router.push("/");
    },
    reset_password() {
      this.errorMessage.message = "";
      this.password.new = "";
      this.password.confirm = "";
      this.reset_all();
      this.resetModal = true;
    },
    reset_all() {
      this.hasErrors.new = false;
      this.hasErrors.confirm = false;
      this.errorMessage.new = "";
      this.errorMessage.confirm = "";
    },
    Submit() {
      this.errorMessage.message = "";
      this.reset_all();
      var submit = 0;
      var pass = /^((?!.*[\s])(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{8,20})$/;
      if (this.password.new.length == 0) {
        submit = 1;
        this.hasErrors.new = true;
        this.errorMessage.new = "Password Required";
      } else if (pass.test(this.password.new) == false) {
        submit = 1;
        this.hasErrors.new = true;
        this.errorMessage.new =
          "8 characters including 1 uppercase letter, 1 special character & alphanumeric characters without space";
      }
      if (this.password.confirm.length == 0) {
        submit = 1;
        this.hasErrors.confirm = true;
        this.errorMessage.confirm = "Confirm Password Required";
      } else if (this.password.confirm != this.password.new) {
        submit = 1;
        this.hasErrors.confirm = true;
        this.errorMessage.confirm =
          "Password and Confirm Password doesnot match";
      }
      if (submit == 0) {
        this.handleSubmit();
      }
    },
    handleSubmit() {
      var _this = this;
      var pass = {};
      _this.loading = true;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      pass.newPassword = this.password.new;
      this.$http
        .post("/api/users/reset-password", pass)
        .then(function (response) {
          _this.reset_password();
          _this.reset_all();
          _this.loading = false;
          _this.errorMessage.message = " Password Changed Successfully !!";
        })
        .catch(function (error) {
          _this.loading = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Header/HeaderDropdown.vue